import { defineComponent as _defineComponent } from 'vue'
import { DdPage } from "@/CodegenTypes";
import { formatCount } from "@/helpers/formatCount";
import { formatDollar } from "@/helpers/formatDollar";
import { customMoment } from "@/main";
import { useTranslation } from "@/store/translation";


export default /*#__PURE__*/_defineComponent({
  __name: 'DdPageMeta',
  props: {
    page: null
  },
  setup(__props: any) {

const props = __props as {
  page: DdPage;
};

const { $t } = useTranslation();




function formatDate(dateStr: string) {
  return customMoment(dateStr).format("ddd, DD/MM/YYYY hh:mm:ssA");
}

return { __sfc: true,$t, props, formatDate, formatCount, formatDollar }
}

})